import { memo } from 'react'
import { PropTypes } from 'prop-types'

import { Container, InnerContainer } from './styles'

const ScreenContainer = memo(
  ({ children = null, removePaddingTop = false, removePaddingBottom = false, fillScreen = false }) => (
    <Container removePaddingTop={removePaddingTop} removePaddingBottom={removePaddingBottom} fillScreen={fillScreen}>
      <InnerContainer>{children}</InnerContainer>
    </Container>
  ),
)

ScreenContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf([PropTypes.node])]),
  removePaddingTop: PropTypes.bool,
  removePaddingBottom: PropTypes.bool,
  fillScreen: PropTypes.bool,
}

export default ScreenContainer
